'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListTypeDropdown = require('./components/ListTypeDropdown.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListTypeDropdown).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type-dropdown/index.js
// module id = 1316
// module chunks = 0